import * as style from './style.module.css';

const FormGrid = ({  children }) => {
  return (
    <div className={style.formGrid}>
      {children}
    </div>
  );
};

export default FormGrid;
